import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { EbComponent } from "src/app/components/eb/eb.component";
import { BillingProfile } from "src/app/interface/user";
import { AlertService } from "src/app/services/alert.service";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "app-card-billing-profile",
  templateUrl: "./card-billing-profile.component.html",
  styleUrl: "./card-billing-profile.component.less",
})
export class CardBillingProfileComponent {
  @Input() profile: BillingProfile;
  @Input() showActions: boolean;
  @Output() profileUpdated = new EventEmitter<void>();
  ngOnInit(): void {}
  constructor(
    private dialog: MatDialog,
    private alertService: AlertService,
    private apiService: ApiService
  ) {}
  eb = () =>
    this.dialog
      .open(EbComponent, {
        height: "100%",
        width: "100%",
        maxWidth: "100%",
        panelClass: "iframe-class",
        data: { id: this.profile.id },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result && result !== "closedManually") {
          this.alertService.openSnackBar(
            "Datos del perfil de facturación guardados con éxito.",
            "success"
          );
          this.profileUpdated.emit();
        } else if (result === "closedManually") return;
        else {
          this.alertService.openSnackBar(
            "Error al guardar los datos del perfil de facturación.",
            "error"
          );
        }
      });
  setDefault() {
    if (!this.profile.Default) {
      this.apiService
        .editBillingProfileDefault(
          Number(this.profile.id),
          Number(this.profile.User.id)
        )
        .subscribe((res) => {
          if (res) {
            this.profile.Default = true;
            this.alertService.openSnackBar(
              "Perfil de facturación establecido como predeterminado.",
              "success"
            );
          } else {
            this.alertService.openSnackBar(
              "Error al establecer el perfil de facturación como predeterminado.",
              "error"
            );
          }
        });
    }
  }
}
